import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function PageShell({ title, subtitle, breadcrumb, children }) {
  return (
    <div>
      {/* Header banner */}
      <section className="bg-secondary/50 border-b border-border">
        <div className="max-w-4xl mx-auto px-6 py-14 md:py-20 text-center">
          <span className="text-primary text-xs font-semibold tracking-[0.2em] uppercase">
            RADIX
          </span>
          <h1 className="font-serif text-4xl md:text-5xl mt-3 mb-3">{title}</h1>
          {subtitle && (
            <p className="text-muted-foreground max-w-2xl mx-auto">{subtitle}</p>
          )}
        </div>
      </section>

      <div className="max-w-3xl mx-auto px-6 py-10">
        <nav className="text-sm text-muted-foreground mb-8 flex items-center gap-1">
          <Link to="/" className="hover:text-primary">Início</Link>
          <ChevronRight className="h-3.5 w-3.5" />
          <span className="text-foreground">{breadcrumb || title}</span>
        </nav>
        <article className="space-y-8">{children}</article>
      </div>
    </div>
  );
}

export function Section({ title, children }) {
  return (
    <section>
      {title && <h2 className="font-serif text-2xl mb-3">{title}</h2>}
      <div className="text-[15px] leading-relaxed text-muted-foreground space-y-3">
        {children}
      </div>
    </section>
  );
}
